import { toBool, WorkflowGroup, WorkflowLogItem } from 'vopay';
import { useState } from 'react';
import apiConfig from '@/services/api.config';
import { usePermissions } from '@/providers/Permissions.provider';
import { useClientData } from '@/providers/ClientData.provider';

const { api } = apiConfig;

export default function useFetchWorkflows({ bearer }: { bearer?: string } = {}) {
  const [workflows, setWorkflows] = useState<WorkflowGroup[]>([]);
  const [fetchingWorkflows, setFetchingWorkflows] = useState(false);
  const [workflowLogs, setWorkflowLogs] = useState<WorkflowLogItem[]>([]);
  const [fetchingWorkflowLogs, setFetchingWorkflowLogs] = useState(false);
  const { permissions } = usePermissions();

  const {
    response: { TransactionApprovalWorkflowEnabled },
  } = useClientData();

  async function fetchWorkflows(bearerToken?: string) {
    if (!bearerToken && (!permissions.ViewTransactionApprovalWorkflow || !toBool(TransactionApprovalWorkflowEnabled))) {
      return;
    }

    try {
      setFetchingWorkflows(true);
      const res = await api.fetchWorkflows(undefined, bearerToken ?? bearer);

      if (!res.Success) throw new Error(res.ErrorMessage);
      setWorkflows(res.Workflows);
      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingWorkflows(false);
    }
  }

  async function fetchWorkflowLogs(workflowID?: string) {
    if (!permissions.ViewTransactionApprovalWorkflow || !toBool(TransactionApprovalWorkflowEnabled)) {
      return;
    }

    try {
      setFetchingWorkflowLogs(true);
      const res = await api.fetchWorkflowLogs({ WorkflowID: workflowID });

      if (!res.Success) throw new Error(res.ErrorMessage);
      setWorkflowLogs(res.Logs);
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingWorkflowLogs(false);
    }
  }

  return {
    workflows,
    fetchWorkflows,
    fetchingWorkflows,
    workflowLogs,
    fetchWorkflowLogs,
    fetchingWorkflowLogs,
  };
}
